import { render, staticRenderFns } from "./detailsProject.vue?vue&type=template&id=11f6a314&scoped=true"
import script from "./detailsProject.vue?vue&type=script&lang=js"
export * from "./detailsProject.vue?vue&type=script&lang=js"
import style0 from "./detailsProject.vue?vue&type=style&index=0&id=11f6a314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6a314",
  null
  
)

export default component.exports